import { configureStore } from '@reduxjs/toolkit';
import rootReducer from './reducers';
import authServices from '../services/authServices';
export default configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
  getDefaultMiddleware({
    thunk: {
      extraArgument: authServices,
    },
    serializableCheck: false,
  }),
});
